import { characters } from "@/mocks/site";

export default function CharacterSection() {
  return (
    <section id="characters" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">Characters</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">人物档案</h2>
          <p className="mt-2 text-sm text-foreground-600">
            这类题材的角色设置高度相似，认识下面五个固定位置，看任何一部都能快速对上号。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {characters.map((role) => (
            <article
              key={role.id}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-accent-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-900">
                <i className="ri-user-3-line text-xl" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{role.role}</h3>
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                    {role.identity}
                  </span>
                </div>
                <p className="mt-2 text-sm font-medium text-primary-700">{role.trait}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{role.detail}</p>
                <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-folder-open-line text-xs" aria-hidden="true" />
                  </span>
                  {role.appears}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}